module.exports = __webpack_public_path__ + "img/search.2fae78be.svg";